/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./StepperHeader.module.css";
import StepperStep from "./StepperStep";

const StepperHeader: React.FC = () => {
  const steps = [
    {
      number: 1,
      label: "Select Premium Type",
      status: "active" as const,
      showIcon: true,
    },
    { number: 2, label: "Select Office*", status: "current" as const },
    { number: 3, label: "Select Product", status: "inactive" as const },
    { number: 4, label: "Create Product", status: "inactive" as const },
  ];

  return (
    <header className={styles.stepperHeader}>
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          <StepperStep {...step} />
          {index < steps.length - 1 && <div className={styles.divider} />}
        </React.Fragment>
      ))}
    </header>
  );
};

export default StepperHeader;
